// fichier permettant de faire de la manipulation en rapprt avec des chaines de caractères
const stringHelper = {

    escapeRegExp(value) {
        return value.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
    },

    /**
     * Coupe une chaine de caractère trop grande et ajoute une fin custom
     * @param {string} str 
     * @param {number} maxLength 
     */
    truncateString(str, maxLength) {
        if (str.length > maxLength) {
        return str.slice(0, maxLength) + '...';
        }
        return str;
    },

    isUnsignedInteger(value) {
        // On limite à 15 le nombre de caratère pour éviter tout problème de conversion (voir Number.MAX_SAFE_INTEGER)
        return /^[0-9]{1,15}$/.test(value);
    }

}

export default stringHelper;
